import * as React from "react";
import {
  OutletContextProps,
  WithRouterProps,
} from "../../helpers/RouterHelper";
import enhanceSectionsSettingsPage from "../../hocs/enhanceSectionsSettingsPage";
import SectionInterface from "../../interfaces/SectionInterface";
import SectionsSettingsKarteTemplatesEdit from "./SectionsSettingsKarteTemplatesEdit";

interface Props
  extends WithRouterProps<{ karteTemplateId: string }>,
    OutletContextProps {
  section: SectionInterface;
}

class SectionsSettingsKarteTemplatesEditPage extends React.Component<Props> {
  constructor(props: Props) {
    super(props);
    props.setActiveMenu("template");
  }

  render() {
    const { karteTemplateId } = this.props.params;
    return (
      <SectionsSettingsKarteTemplatesEdit
        section={this.props.section}
        karteTemplateId={karteTemplateId}
      />
    );
  }
}

const pageInfo = {
  title: "テンプレート",
};

export default enhanceSectionsSettingsPage(
  SectionsSettingsKarteTemplatesEditPage,
  pageInfo,
);
